export default {
    "vgw_platform": {
        "url": process.env.VUE_APP_VGW_PLATFORM_URL
    }
}